import template from './expander.tmpl.html';
import WsExpanderController from './expander.controller';

const ExpanderComponent = {
  template,
  controller: WsExpanderController,
  bindings: {
    showText: '@?',
    hideText: '@?',
    toggleWidthPercent: '@?',
    expanded: '<?',
    onExpand: '&?',
    onCollapse: '&?',
  },
  transclude: {
    header: '?wsExpanderHeader',
    body: 'wsExpanderBody',
  },
};

export default ExpanderComponent;



// WEBPACK FOOTER //
// ./src/expander/expander.component.js